var GNav = {
  // btn01用のオブジェクト

  path: undefined,

  init:function () {
    if($('#js-lnav')[0]){
      this.setLnav();
      this.definePath();
      this.toggleClass();
    }
  },

  setLnav: function() {
    var module = '<ul class="lists" id="js-lnav-list">' +
                    '<li><a href="/about/process/">プロジェクトの拡大経緯</a></li>' +
                    '<li><a href="/about/assistance/">TAP PROJECT JAPANの支援先</a></li>' +
                    '<li><a href="/about/worldwide/">世界での展開</a></li>' +
                    '<li><a href="/about/health/">水と衛生について</a></li>' +
                    '<li><a href="/about/partner/">協賛パートナー</a></li>' +
                  '</ul>' +
                  '<div class="cover">' +
                    '<ul class="dots">' +
                      '<li><span></span></li>' +
                      '<li><span></span></li>' +
                      '<li><span></span></li>' +
                      '<li><span></span></li>' +
                      '<li><span></span></li>' +
                    '</ul>' +
                    '<a class="lnav-btn" href="javascript:void(0)" id="js-lnav-btn"></a>' +
                  '</div>';
    $('#js-lnav').append(module);
  },

  toggleClass: function() {
    var $btn = $('#js-lnav-btn');
    var $target = $('#js-lnav-list');
    $btn.on('click',function(){
      $target.toggleClass('is-active');
      $btn.toggleClass('is-active');
    });
  },

  definePath: function () {
    this.path = location.pathname.split('/')[2];
    switch (this.path){
      case 'process':
        this.addClass(0);
        break;
      case 'assistance':
        this.addClass(1);
        break;
      case 'worldwide':
        this.addClass(2);
        break;
      case 'health':
        this.addClass(3);
        break;
      case 'partner':
        this.addClass(4);
        break;
      default:
      break;
    }
  },

  addClass: function(i) {
    $('#js-lnav').find('.dots').find('li').eq(i).addClass('is-active');
    $('#js-lnav').find('.lists').find('li').eq(i).addClass('is-active');
  }



};



module.exports = GNav;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_lNav.js
// module id = 8
// module chunks = 0